// descomentar apenas para apps Laravel (fullstack)
// (nesse arquivo o token CSRF eh inserido nos headers padrao do axios)
//require('./bootstrap');

/**
 * Arquivo JavaScript principal.
 * A partir daqui são incluídas todas as dependências.
 */
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import Vuelidate from "vuelidate";
import VueProgressBar from "vue-progressbar";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUser,
  faSignOutAlt,
  faTrashAlt,
  faTrashRestoreAlt,
  faTimes,
  faSave,
  faEye,
  faEdit,
  faShoppingBasket,
  faMapMarked,
  faCalendar,
  faSearch,
  faCheck,
  faTicketAlt,
  faTasks,
  faQuestionCircle,
  faPhone,
  faCommentDots,
  faUsers,
  faPeopleCarry,
  faClock,  
  faArrowLeft,
  faDollarSign,
  faFilePdf,
  faUserEdit,
  faFileImport,
  faFileDownload,
  faPlus,
  faMinus,
  faExclamationTriangle,
  faFileCsv,
  faFile,
  faExclamationCircle,
  faShareSquare,
  faCheckCircle,
  faExchangeAlt,
  faUsersCog,
  faFileExcel,
  faFileInvoiceDollar,
  faAt,
} from "@fortawesome/free-solid-svg-icons";

import {
  faWhatsappSquare,
  faTelegram,
} from "@fortawesome/free-brands-svg-icons";

import {
    faCreditCard,
    faPlusSquare,
} from "@fortawesome/free-regular-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import PiwebLibVue from '@prodabel/piweb-lib-vue';
//import "@prodabel/piweb-lib-vue/dist/public/css/style.css";

// descomentar a linha abaixo para habilitar o login

//import permissions from './permissions.json';

import router from './routes';
import store from './stores';
import keycloakvue from '@prodabel/vue-keycloak-adapter';
import helpers from './helpers';
import filters from './filters';
import Root from './pages/paginaRaiz.vue';
import api from './requests';
import constantes from './constants/index';

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
library.add(
    faUser,
    faSignOutAlt,
    faTrashAlt,
    faTrashRestoreAlt,
    faTimes,
    faSave,
    faEye,
    faEdit,
    faShoppingBasket,
    faMapMarked,
    faCalendar,
    faSearch,
    faCheck,
    faTicketAlt,
    faTasks,
    faQuestionCircle,
    faPhone,
    faWhatsappSquare,
    faTelegram,
    faCommentDots,
    faUsers,
    faPeopleCarry,
    faClock,
    faArrowLeft,
    faFile,
    faDollarSign,
    faFilePdf,
    faUserEdit,
    faFileImport,
    faFileDownload,
    faPlus,
    faMinus,
    faExclamationTriangle,
    faCreditCard,
    faFileCsv,
    faExclamationCircle,
    faShareSquare,
    faCheckCircle,
    faPlusSquare,
    faExchangeAlt,
    faUsersCog,
    faFileExcel,
    faFileInvoiceDollar,
    faAt
  );
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(PiwebLibVue, {
    merge: {
        filters,
        helpers
    }
});



Vue.prototype.$api = api;
Vue.prototype.$helpers = helpers;
Vue.prototype.$constantes = constantes;



// descomentar a linha abaixo para habilitar o login
helpers.getEnv().then((env) => {

    Vue.use(keycloakvue, { 
        store, 
        router,
        seconds_to_refresh: 60,
        permissions: {
            SUPERADMINISTRADOR: [
                "admin",
                "historico",
                "action-edit-nome-visualizado",
                "action-remove-familia",
                "importacaofamilias",
                "exportacaofamiliassemconta",
                "beneficiosbeneficiarioForm",
                "beneficiarios", 
                "beneficiarioForm",
                "parametros",
                "parametrosform",
                "controlePagamentos",
                "contaBancaria",
                "beneficiariosSemConta",
                "arquivocriacaoconta",
                "importacaoRetornoBuscaConta",
                "importacaoRetornoAberturaConta",
                "visualizarPagamento",
                "liberacaoPagamento",
                "parametrosPagamento",
                "parametrosPagamentoform",
                "apiCidadao",
                "manutencao",
                "alteracaoResponsavel",
                "geracaoParcela",
                "consolidadoPagamento",
                "configurarPagamento",
            ],
            ADMINISTRADOR: ["admin", "historico", "beneficiarios", "beneficiarioForm", "beneficiosbeneficiarioForm","controlePagamentos","contaBancaria","alteracaoResponsavel"],
            CONSULTA: ["admin", "historico", "beneficiarios", "beneficiarioForm", "beneficiosbeneficiarioForm","controlePagamentos"],
            any: ["home", "info", "foraperiodo", "dadoscomplementares", "confirmacao","beneficiarioFormAlterarResponsavel"]
        },
        
        redirect_url_logout: window.location.protocol + "//" + window.location.host,
        options: {
          redirectUri: window.location.protocol + '//' + window.location.host + window.location.pathname +
                      (window.location.search ? window.location.search : ''),
          },
          optionsConst: {
            "url": env.ACESSO_URL,
            "realm": "PBH",
            "auth-server-url": env.ACESSO_URL,
            "ssl-required": "external",
            "resource": "ESTAMOSJUNTOS",
            "public-client": true,
            "use-resource-role-mappings": true,
            "confidential-port": 0,
            "clientId": "ESTAMOSJUNTOS"
        },
     })
    

    Vue.use(VueProgressBar, {
        color: "#28a745",
        failedColor: "#874b4b",
        thickness: "5px",
    });

    Vue.prototype.$env = env;

    store.subscribe((mutation, state) => {// eslint-disable-line no-unused-vars 
        if (mutation.type == 'SET_KEYCLOAK') {
          router.setUserRoles(store.getters.userRoles, router);
        }
      })

    new Vue({
        data() {
            return {
                carregando: false,
            }
        },
        store,
        router,
        render: h => h(Root),
    }).$mount('#app')

});